import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Button,
  Table,
  Row,
  Col,
  Space,
  Modal,
  Form,
  Input,
  message,
  Upload,
} from "antd";
import imageCompression from "browser-image-compression";
import { useDebouncedCallback } from "use-debounce";
import ImgCrop from "antd-img-crop";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Layout from "../../../components/Layout";
import { FiExternalLink } from "react-icons/fi";
import { ReloadOutlined, LinkOutlined, PlusOutlined } from "@ant-design/icons";
import { COLORS } from "../../../config/theme";
import { API, request, Domain } from "../../../config/API";
import { openNotification } from "../../../redux/actions/Notification/notifications.action";
import authHeader from "../../../redux/services/authHeader";
import { formatDistanceToNow } from "date-fns";
import AddWalletButton from "../../../components/AddWalletButton";
import {
  RiFacebookBoxFill,
  RiInstagramFill,
  RiLinkedinBoxFill,
  RiTwitterFill,
  RiYoutubeFill,
} from "react-icons/ri";
import { profileImgPlaceholder } from "../../../assets/images";
import QRCode from "../../../components/QRCode";
import LocationSearch from "../../../components/LocationSearch";
const iconNames = require("../../../helpers/ICONS.json");

const MyQr = () => {
  const [myQr, setMyQr] = useState([]);
  const [count, setCount] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { primaryDark } = COLORS;
  const dispatch = useDispatch();
  const [form1] = Form.useForm();
  const formRef1 = useRef(null);
  const { Item } = Form;
  const { Search } = Input;
  const controller = new AbortController();
  // pagination

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  function handlePageChange(current) {
    setCurrentPage(current);
  }
  function handleSizeChange(a, b, c) {
    setCurrentPage(a);
    setPageSize(b);
  }

  const onRefresh = () => {
    setIsLoading(true);

    request
      .get(`qr/myQr`, {
        params: {
          pageSize,
          pageNumber: currentPage,
        },
        headers: { ...authHeader() },
      })
      .then(({ data: { data } }) => {
        setMyQr(data?.qr);
        setCount(data?.count);

        setIsLoading(false);
        // getSingleUser();
      })
      .catch((err) => {
        const error = err?.response?.data?.data || "Something Went Wrong";
        openNotification({
          message: "Error!",
          description: error,
          icon: "error",
        });
        setIsLoading(false);
      });
  };
  ///////////////////////////// Quick Edit \\\\\\\\\\\\\\\\\\\\\\\\\\\
  const [quickEditCard, setQuickEditCard] = useState({}); // to select the card and show the quick edit modal
  const [locationInfo, setLocationInfo] = useState({});
  const [isEditting, setIsEditing] = useState(false);
  const [isFacebook, setIsFacebook] = useState(false);
  const [isInstagram, setIsInstagram] = useState(false);
  const [isLinkedin, setIsLinkedin] = useState(false);
  const [isTwitter, setIsTwitter] = useState(false);
  const [isYoutube, setIsYoutube] = useState(false);
  const [iconModal, setIconModal] = useState("");
  const [websites, setWebsites] = useState([]);
  const [searchIconValue, setSearchIconValue] = useState("");
  const [searchedIcon, setSearchIcons] = useState([]);
  const handleQuickEdit = (e) => {
    setQuickEditCard({ ...quickEditCard, [e.target.name]: e.target.value });
  };
  const setFormSocialLinks = useCallback(
    () => (fieldName, value) => {
      form1.setFieldsValue({ [fieldName]: value });
    },
    [form1]
  );
  useEffect(() => {
    if (Object.keys(quickEditCard).length > 0) {
      quickEditCard.socialLinks.forEach(({ name, link, id }) => {
        if (name === "facebook" && link) {
          setIsFacebook(true);
          setFormSocialLinks("facebook", link);
        }
        if (name === "instagram" && link) {
          setIsInstagram(true);
          setFormSocialLinks("instagram", link);
        }
        if (name === "linkedin" && link) {
          setIsLinkedin(true);
          setFormSocialLinks("linkedin", link);
        }
        if (name === "twitter" && link) {
          setIsTwitter(true);
          setFormSocialLinks("twitter", link);
        }
        if (name === "youtube" && link) {
          setIsYoutube(true);
          setFormSocialLinks("youtube", link);
        }
      });
    }
  }, [quickEditCard, setFormSocialLinks]);
  const onWebsiteValueChange = (e, _id) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < existingWebsites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          [e.target.name]:
            e.target.name === "link"
              ? e.target.value.replace("https://", "")
              : e.target.value,
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setWebsites(existingWebsites);
  };
  const handleCloseQuickEditModal = () => {
    setQuickEditCard({});
    setIsFacebook(false);
    setIsInstagram(false);
    setIsTwitter(false);
    setIsLinkedin(false);
    setIsYoutube(false);
    form1.resetFields();
  };
  const EditQr = () => {
    const socialLinks = [
      {
        name: "facebook",
        link: form1?.getFieldValue("facebook")
          ? form1?.getFieldValue("facebook")?.includes("facebook.com")
            ? form1.getFieldValue("facebook")
            : "facebook.com/" + form1.getFieldValue("facebook")
          : "",
      },
      {
        name: "instagram",
        link: form1?.getFieldValue("instagram")
          ? form1?.getFieldValue("instagram")?.includes("instagram.com")
            ? form1.getFieldValue("instagram")
            : "instagram.com/" + form1.getFieldValue("instagram")
          : "",
      },
      {
        name: "linkedin",
        link: form1?.getFieldValue("linkedin")
          ? form1?.getFieldValue("linkedin")?.includes("linkedin.com")
            ? form1.getFieldValue("linkedin")
            : "linkedin.com/" + form1.getFieldValue("linkedin")
          : "",
      },
      {
        name: "twitter",
        link: form1?.getFieldValue("twitter")
          ? form1?.getFieldValue("twitter")?.includes("twitter.com")
            ? form1?.getFieldValue("twitter")
            : "twitter.com/" + form1?.getFieldValue("twitter")
          : "",
      },
      {
        name: "skype",
        link: form1?.getFieldValue("skype")
          ? form1?.getFieldValue("skype")?.includes("skype.com")
            ? form1?.getFieldValue("skype")
            : "skype.com/" + form1?.getFieldValue("skype")
          : "",
      },
      {
        name: "behance",
        link: form1?.getFieldValue("behance")
          ? form1?.getFieldValue("behance")?.includes("behance.com")
            ? form1?.getFieldValue("behance")
            : "behance.com/" + form1?.getFieldValue("behance")
          : "",
      },
      {
        name: "youtube",
        link: form1?.getFieldValue("youtube")
          ? form1?.getFieldValue("youtube")?.includes("youtube.com")
            ? form1?.getFieldValue("youtube")
            : "youtube.com/" + form1?.getFieldValue("youtube")
          : "",
      },
      {
        name: "whatsapp",
        link: form1?.getFieldValue("whatsapp")
          ? form1?.getFieldValue("whatsapp")?.includes("wa.me")
            ? form1?.getFieldValue("whatsapp")
            : "wa.me/" + form1?.getFieldValue("whatsapp")
          : "",
      },
      {
        name: "maps",
        link: form1?.getFieldValue("maps")
          ? form1?.getFieldValue("maps")?.includes("goo.gl/maps")
            ? form1?.getFieldValue("maps")
            : "goo.gl/maps/" + form1?.getFieldValue("maps")
          : "",
      },
      { name: "mail", link: form1?.getFieldValue("mail") },
      {
        name: "telegram",
        link: form1?.getFieldValue("telegram")
          ? form1?.getFieldValue("telegram")?.includes("t.me")
            ? form1?.getFieldValue("telegram")
            : "t.me/" + form1?.getFieldValue("telegram")
          : "",
      },
      {
        name: "tiktok",
        link: form1?.getFieldValue("tiktok")
          ? form1?.getFieldValue("tiktok")?.includes("vt.tiktok.com")
            ? form1?.getFieldValue("tiktok")
            : "vt.tiktok.com/" + form1?.getFieldValue("tiktok")
          : "",
      },
      {
        name: "snapchat",
        link: form1?.getFieldValue("snapchat")
          ? form1?.getFieldValue("snapchat")?.includes("snapchat.com/add")
            ? form1?.getFieldValue("snapchat")
            : "snapchat.com/add/" + form1?.getFieldValue("snapchat")
          : "",
      },
    ];
    setIsEditing(true);
    request
      .put(API + "/qr/quickUpdate/" + quickEditCard?._id, {
        ...quickEditCard,
        webLinks: websites,
        locationInfo,
        socialLinks,
      })
      .then((data) => {
        setIsEditing(false);
        message.success("QR Updated");
        handleCloseQuickEditModal();
        onRefresh();
      })
      .catch((err) => {
        openNotification({
          message: "Error",
          description: err?.response?.data?.data,
          icon: "error",
        });
        setIsEditing(false);
      });
  };
  const handleRemoveIcon = (_id) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          icon: "",
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setWebsites(existingWebsites);
  };
  const handleAddCustomIcon = ({ file, onSuccess, onError }, _id) => {
    const options = {
      signal: controller.signal,
      maxSizeMB: 0.05,
    };
    const formData = new FormData();
    imageCompression(file, options)
      .then(function (compressedFile) {
        formData.append("customIcon", compressedFile);
        request
          .post("qr/images", formData, {
            headers: { "Content-Type": "multipart/form-data", ...authHeader() },
          })
          .then(({ data: { data } }) => {
            onSuccess();
            const existingWebsites = [...websites];
            for (let index = 0; index < websites.length; index++) {
              if (_id === existingWebsites[index]?._id) {
                const toChangeWebsite = { ...existingWebsites[index] };
                const tempWebsite = {
                  ...toChangeWebsite,
                  image: data.customIcon,
                };
                existingWebsites[index] = tempWebsite;
              }
            }
            setIconModal("");
            setWebsites(existingWebsites);
          })
          .catch((err) => {
            console.error(err.response);
            message.error(
              err?.response?.data?.data || "Image size limit 500kb"
            );
            onError();
          });
        return;
        // return uploadToServer(compressedFile); // write your own logic
      })
      .catch(function (error) {
        console.log(error.message); // output: I just want to stop
      });
  };
  const handleImageRemove = (image, key) => {
    request
      .put(
        `qr/image/${quickEditCard._id}`,
        { [key]: image },
        { headers: { ...authHeader() } }
      )
      .then(() => {})
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
      });
  };
  const handleRemoveCustomIcon = (image, _id) => {
    request
      .put("qr/image", { image }, { headers: { ...authHeader() } })
      .then(() => {})
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
      });
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          image: "",
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setWebsites(existingWebsites);
  };
  const handleAddIcon = (_id, icon) => {
    const existingWebsites = [...websites];
    for (let index = 0; index < websites.length; index++) {
      if (_id === existingWebsites[index]?._id) {
        const toChangeWebsite = { ...existingWebsites[index] };
        const tempWebsite = {
          ...toChangeWebsite,
          icon: icon,
        };
        existingWebsites[index] = tempWebsite;
      }
    }
    setIconModal("");
    setWebsites(existingWebsites);
  };
  const handleSearchIcon = () => {
    if (!searchIconValue) {
      setSearchIcons([]);
      return;
    }
    const searchedIcon = iconNames.filter((item) => {
      return item.match(searchIconValue.toLowerCase());
    });
    if (searchedIcon.length > 0) {
      setSearchIcons(searchedIcon);
    } else {
      setSearchIcons([]);
    }
  };
  const debounced = useDebouncedCallback(() => {
    handleSearchIcon();
  }, 500);
  useEffect(() => {
    if (!searchIconValue) {
      setSearchIcons([]);
      return;
    }
    debounced(searchIconValue);
  }, [debounced, searchIconValue]);
  ////////////////////\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
  useEffect(() => {
    onRefresh();
    //eslint-disable-next-line
  }, [dispatch, currentPage, pageSize]);
  const columns = [
    {
      width: "10%",
      title: "Profile",
      dataIndex: "profileImage",
      key: "profileImage",
      render: (image) => (
        <img
          draggable={false}
          style={{ aspectRatio: 1, width: "3.5rem", borderRadius: "1.7rem" }}
          src={image ? `${Domain}/data/${image}` : profileImgPlaceholder}
          alt=""
        />
      ),
    },
    {
      width: "10%",
      title: () => <p id="link_title"> Link</p>,
      dataIndex: "link",
      key: "link",
      render: (text) => (
        <Link target="_blank" to={"/wc/" + text}>
          {text}
        </Link>
      ),
    },
    {
      width: "20%",
      title: "Created By",
      dataIndex: ["owner", "fullName"],
      key: "owner",
    },
    {
      width: "20%",
      title: "Card Name",
      key: "qrName",
      dataIndex: "fName",
      render: (row, entry) => `${row} ${entry?.lName && entry?.lName}`,
    },
    {
      width: "20%",
      title: "Total Scans",
      dataIndex: "count",
      key: "count",
    },
    {
      width: "20%",
      title: "Last Updated/Scanned",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text) =>
        formatDistanceToNow(new Date(text), { addSuffix: true }),
    },
    {
      width: "10%",
      title: "Export card to wallet app",
      dataIndex: "_id",
      key: "_id",
      render: (text) => {
        return <AddWalletButton vCard={{ _id: text }}></AddWalletButton>;
      },
    },
    {
      width: "10%",
      title: "Actions",
      key: "actions",
      render: (text) => {
        return (
          <Space size="large">
            <Button
              id="edit_card_button"
              shape="round"
              onClick={() =>
                window.open(`edit-wave-card/${text?.link}`, "_blank")
              }
            >
              Edit
            </Button>
            <Button
              shape="round"
              onClick={() => {
                form1.resetFields();
                setQuickEditCard(text);
                setWebsites(text.webLinks);
              }}
            >
              Quick Edit
            </Button>
            <div>
              <Button
                shape="round"
                onClick={() => {
                  const canvas = document.getElementsByClassName(
                    `${text.link}`
                  )[0].firstChild;
                  const pngUrl = canvas
                    ?.toDataURL("image/png")
                    ?.replace("image/png", "image/octet-stream");
                  let downloadLink = document.createElement("a");
                  downloadLink.href = pngUrl;
                  downloadLink.download = text.link + ".png";
                  document.body.appendChild(downloadLink);
                  downloadLink.click();
                  document.body.removeChild(downloadLink);
                }}
              >
                Download Qr
              </Button>
              <div
                className={`qrcode ${text.link}`}
                style={{
                  display: "none",
                }}
              >
                <QRCode
                  size={text?.qrSetting?.size}
                  value={`${
                    process.env.REACT_APP_DOMAIN_URL ||
                    "https://wavecodes.com.au"
                  }/wc/${text?.link}`}
                  quietZone={text?.qrSetting?.quietZone}
                  fgColor={text?.qrSetting?.fgColor}
                  bgColor={text?.qrSetting?.bgColor}
                  ecLevel={text?.qrSetting?.ecLevel}
                  qrStyle={text?.qrSetting?.qrStyle}
                  eyeRadius={text?.qrSetting?.eyeRadius}
                  logoImage={text?.qrSetting?.logoImage}
                  logoWidth={text?.qrSetting?.logoWidth}
                  logoHeight={text?.qrSetting?.logoHeight}
                  logoOpacity={text?.qrSetting?.logoOpacity}
                />
              </div>
            </div>
          </Space>
        );
      },
    },
  ];

  return (
    <Layout heading="My Cards" hasBadge stat={count}>
      <Row gutter={0} style={{ marginBottom: 24 }}>
        <Col
          span={24}
          style={{
            display: "flex",
            justifyContent: "end",
          }}
        >
          <Space>
            <Button
              shape="round"
              type="primary"
              style={{
                background: primaryDark,
                borderColor: primaryDark,
              }}
              onClick={onRefresh}
              icon={<ReloadOutlined />}
              loading={isLoading}
            >
              Refresh
            </Button>
          </Space>
        </Col>
      </Row>
      <Table
        size="large"
        dataSource={myQr}
        rowKey={({ _id }) => _id}
        columns={columns}
        loading={isLoading}
        pagination={{
          hideOnSinglePage: true,
          pageSize: pageSize,
          current: currentPage,
          total: count,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
          // showTotal: (total) => `Total ${total} items`,
          onChange: handlePageChange,
          showSizeChanger: true,
          onShowSizeChange: handleSizeChange,
        }}
      />
      {/* Quick Edit Modal */}
      <Modal
        visible={Object.keys(quickEditCard).length > 0 ? true : false}
        title="Quick Edit"
        footer={null}
        onCancel={handleCloseQuickEditModal}
      >
        <Col>
          <Form
            name="quickEdit"
            form={form1}
            ref={formRef1}
            onFinishFailed={(err) => console.error(err)}
          >
            {/* First Name */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="First Name"
              initialValue={quickEditCard.fName}
              rules={[{ required: true, message: "This field is required" }]}
            >
              <Input
                size="large"
                name="fName"
                value={quickEditCard.fName}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="First Name"
              />
            </Item>
            {/* Last Name */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Last Name"
              hasFeedback
              initialValue={quickEditCard.lName}
            >
              <Input
                size="large"
                name="lName"
                value={quickEditCard.lName}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="Last Name"
              />
            </Item>
            {/* Phone no */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Phone no"
              hasFeedback
              initialValue={quickEditCard.phone}
            >
              <Input
                size="large"
                name="phone"
                value={quickEditCard.phone}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="Phone no"
              />
            </Item>
            {/* Mobile no */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Mobile no"
              hasFeedback
              initialValue={quickEditCard.mobile}
            >
              <Input
                size="large"
                name="mobile"
                value={quickEditCard.mobile}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="Mobile no"
              />
            </Item>
            {/* email */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Email"
              hasFeedback
              initialValue={quickEditCard.email}
            >
              <Input
                size="large"
                name="email"
                value={quickEditCard.email}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="Email"
              />
            </Item>
            {/* Job title */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Job title"
              hasFeedback
              initialValue={quickEditCard.jobTitle}
            >
              <Input
                size="large"
                name="jobTitle"
                value={quickEditCard.jobTitle}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="Job title"
              />
            </Item>
            {/* Company */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Company"
              hasFeedback
              initialValue={quickEditCard.company}
            >
              <Input
                size="large"
                name="company"
                value={quickEditCard.company}
                onChange={handleQuickEdit}
                style={{ borderRadius: 8 }}
                placeholder="Company"
              />
            </Item>
            {/* Address */}
            <Item
              labelCol={{ span: 7 }}
              labelAlign="left"
              label="Address"
              hasFeedback
              initialValue={quickEditCard.address}
            >
              <LocationSearch
                placeholder="Your Address"
                value={quickEditCard.address}
                onChange={handleQuickEdit}
                name="address"
                setLocationInfo={setLocationInfo}
              />
            </Item>
            {/* first web link */}
            {websites.length > 0 && (
              <Row>
                <Item
                  labelCol={{ span: 7 }}
                  labelAlign="left"
                  label="Web Link"
                  hasFeedback
                  initialValue={quickEditCard.company}
                >
                  <div style={{ marginBottom: "1rem" }}>
                    {websites.map((website, index) => {
                      return (
                        <Space
                          key={index}
                          wrap={true}
                          style={{ marginBottom: "1rem" }}
                        >
                          {website?.icon ? (
                            <i
                              onClick={() => {
                                handleRemoveIcon(website._id);
                              }}
                              className={`fas fa-${website?.icon} fa-2x`}
                              style={{
                                margin: "1rem",
                                // cursor: "pointer",
                              }}
                            />
                          ) : website?.image ? (
                            <img
                              onClick={() => {
                                handleRemoveCustomIcon(
                                  website.image,
                                  website._id
                                );
                              }}
                              src={Domain + "/data/" + website.image}
                              style={{
                                width: "2rem",
                                height: "2rem",
                                // cursor: "pointer",
                                margin: "1rem",
                              }}
                              alt="icon"
                            />
                          ) : (
                            <Button
                              size="large"
                              onClick={() => setIconModal(website._id)}
                              style={{ borderRadius: 8 }}
                            >
                              Icon
                            </Button>
                          )}

                          <Input
                            name="name"
                            style={{ borderRadius: 8 }}
                            placeholder="Link"
                            size="large"
                            value={website.name}
                            onChange={(e) =>
                              onWebsiteValueChange(e, website._id)
                            }
                          />

                          <Input
                            name="link"
                            style={{ borderRadius: 8 }}
                            size="large"
                            value={website.link}
                            placeholder="www.mywebsiteurl.com"
                            prefix={
                              <>
                                <LinkOutlined style={{ paddingRight: 5 }} />
                                {"https://"}
                              </>
                            }
                            onChange={(e) =>
                              onWebsiteValueChange(e, website._id)
                            }
                          />

                          {/* <Button
                            size="large"
                            danger
                            onClick={() => {
                              // handleremoveWebLink(website._id);
                            }}
                            style={{ borderRadius: 8 }}
                            icon={
                              <DeleteOutlined
                                className="linkDeleteIcon"
                                style={{ fontSize: 18 }}
                              />
                            }
                          >
                            Remove
                          </Button> */}
                        </Space>
                      );
                    })}
                  </div>
                </Item>
              </Row>
            )}
            <Row xs={12} md={24} align="center" style={{ gap: 15 }}>
              {/* Facebook */}
              <div
                onClick={() => setIsFacebook(!isFacebook)}
                style={{
                  cursor: "pointer",
                  width: 60,
                  height: 60,
                  borderRadius: 30,
                  border: `1px solid ${isFacebook ? primaryDark : "lightgray"}`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RiFacebookBoxFill
                  color={isFacebook ? primaryDark : "lightgray"}
                  style={{ fontSize: 30 }}
                />
              </div>
              {/* Instagram */}
              <div
                onClick={() => setIsInstagram(!isInstagram)}
                style={{
                  cursor: "pointer",
                  width: 60,
                  height: 60,
                  borderRadius: 30,
                  border: `1px solid ${
                    isInstagram ? primaryDark : "lightgray"
                  }`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RiInstagramFill
                  color={isInstagram ? primaryDark : "lightgray"}
                  style={{ fontSize: 30 }}
                />
              </div>
              {/* linkedin */}
              <div
                onClick={() => setIsLinkedin(!isLinkedin)}
                style={{
                  cursor: "pointer",
                  width: 60,
                  height: 60,
                  borderRadius: 30,
                  border: `1px solid ${isLinkedin ? primaryDark : "lightgray"}`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RiLinkedinBoxFill
                  color={isLinkedin ? primaryDark : "lightgray"}
                  style={{ fontSize: 30 }}
                />
              </div>
              {/* Twitter */}
              <div
                onClick={() => setIsTwitter(!isTwitter)}
                style={{
                  cursor: "pointer",
                  width: 60,
                  height: 60,
                  borderRadius: 30,
                  border: `1px solid ${isTwitter ? primaryDark : "lightgray"}`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RiTwitterFill
                  color={isTwitter ? primaryDark : "lightgray"}
                  style={{ fontSize: 30 }}
                />
              </div>

              {/* Youtube */}
              <div
                onClick={() => setIsYoutube(!isYoutube)}
                style={{
                  cursor: "pointer",
                  width: 60,
                  height: 60,
                  borderRadius: 30,
                  border: `1px solid ${isYoutube ? primaryDark : "lightgray"}`,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RiYoutubeFill
                  color={isYoutube ? primaryDark : "lightgray"}
                  style={{ fontSize: 30 }}
                />
              </div>
            </Row>
            <Row justify="center" style={{ marginTop: "1rem" }}>
              {isFacebook && (
                <Item
                  name="facebook"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    name="facebook"
                    style={{
                      borderRadius: 8,
                      width: "25rem",
                    }}
                    placeholder="yourpage"
                    suffix={
                      <Button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 8,
                        }}
                        icon={<FiExternalLink style={{ marginRight: 5 }} />}
                        onClick={() => {
                          const linkValue = form1.getFieldValue("facebook");
                          let link = linkValue.includes("facebook.com")
                            ? linkValue
                            : "facebook.com/" + linkValue;

                          link = "https://" + link;
                          window.open(link, "_blank");
                        }}
                      >
                        Test
                      </Button>
                    }
                    prefix={
                      <>
                        <RiFacebookBoxFill
                          color="lightgray"
                          style={{
                            fontSize: 30,
                            marginRight: 10,
                          }}
                        />
                        {!form1.getFieldValue("facebook") && "facebook.com/"}
                      </>
                    }
                  />
                </Item>
              )}
              {isInstagram && (
                <Item
                  name="instagram"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    name="instagram"
                    style={{ borderRadius: 8, width: "25rem" }}
                    placeholder="yourpage"
                    suffix={
                      <Button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 8,
                        }}
                        icon={<FiExternalLink style={{ marginRight: 5 }} />}
                        onClick={() => {
                          const linkValue = form1.getFieldValue("instagram");
                          let link = linkValue.includes("instagram.com")
                            ? linkValue
                            : "instagram.com/" + linkValue;

                          link = "https://" + link;
                          window.open(link, "_blank");
                        }}
                      >
                        Test
                      </Button>
                    }
                    prefix={
                      <>
                        <RiInstagramFill
                          color="lightgray"
                          style={{ fontSize: 30, marginRight: 10 }}
                        />
                        {!form1.getFieldValue("instagram") && "instagram.com/"}
                      </>
                    }
                  />
                </Item>
              )}
              {isLinkedin && (
                <Item
                  name="linkedin"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    name="linkedin"
                    style={{ borderRadius: 8, width: "25rem" }}
                    placeholder="yourpage"
                    suffix={
                      <Button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 8,
                        }}
                        icon={<FiExternalLink style={{ marginRight: 5 }} />}
                        onClick={() => {
                          const linkValue = form1.getFieldValue("linkedin");
                          let link = linkValue.includes("linkedin.com")
                            ? linkValue
                            : "linkedin.com/" + linkValue;

                          link = "https://" + link;
                          window.open(link, "_blank");
                        }}
                      >
                        Test
                      </Button>
                    }
                    prefix={
                      <>
                        <RiLinkedinBoxFill
                          color="lightgray"
                          style={{ fontSize: 30, marginRight: 10 }}
                        />
                        {!form1.getFieldValue("linkedin") && "linkedin.com/"}
                      </>
                    }
                  />
                </Item>
              )}
              {isTwitter && (
                <Item
                  name="twitter"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    name="twitter"
                    style={{ borderRadius: 8, width: "25rem" }}
                    placeholder="yourpage"
                    suffix={
                      <Button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 8,
                        }}
                        icon={<FiExternalLink style={{ marginRight: 5 }} />}
                        onClick={() => {
                          const linkValue = form1.getFieldValue("twitter");
                          let link = linkValue.includes("twitter.com")
                            ? linkValue
                            : "twitter.com/" + linkValue;

                          link = "https://" + link;
                          window.open(link, "_blank");
                        }}
                      >
                        Test
                      </Button>
                    }
                    prefix={
                      <>
                        <RiTwitterFill
                          color="lightgray"
                          style={{ fontSize: 30, marginRight: 10 }}
                        />
                        {!form1.getFieldValue("twitter") && "twitter.com/"}
                      </>
                    }
                  />
                </Item>
              )}
              {isYoutube && (
                <Item
                  name="youtube"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input
                    size="large"
                    name="youtube"
                    style={{ borderRadius: 8, width: "25rem" }}
                    placeholder="yourpage"
                    suffix={
                      <Button
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 8,
                        }}
                        icon={<FiExternalLink style={{ marginRight: 5 }} />}
                        onClick={() => {
                          const linkValue = form1.getFieldValue("youtube");
                          let link = linkValue.includes("youtube.com")
                            ? linkValue
                            : "youtube.com/" + linkValue;

                          link = "https://" + link;
                          window.open(link, "_blank");
                        }}
                      >
                        Test
                      </Button>
                    }
                    prefix={
                      <>
                        <RiYoutubeFill
                          color="lightgray"
                          style={{ fontSize: 30, marginRight: 10 }}
                        />
                        {!form1.getFieldValue("youtube") && "youtube.com/"}
                      </>
                    }
                  />
                </Item>
              )}
            </Row>
          </Form>
          <Row
            style={{
              marginTop: "2rem",
              justifyContent: "space-evenly",
            }}
          >
            <Button
              isLoading={isEditting}
              type="primary"
              shape="round"
              style={{
                display: "flex",
                background: primaryDark,
                borderColor: primaryDark,
                width: "8rem",
                justifyContent: "center",
              }}
              size="large"
              onClick={EditQr}
            >
              Save
            </Button>
            <Button
              type="primary"
              shape="round"
              style={{
                display: "flex",
                background: primaryDark,
                borderColor: primaryDark,
                justifyContent: "center",

                width: "8rem",
              }}
              size="large"
              onClick={handleCloseQuickEditModal}
            >
              Cancel
            </Button>
          </Row>
        </Col>
      </Modal>

      {/* Choose Icon */}
      <Modal
        style={{ borderRadius: 13 }}
        bodyStyle={{ paddingLeft: "2rem", paddingRight: "2rem" }}
        visible={!!iconModal}
        title="Choose Weblink Icon"
        footer={null}
        onCancel={() => setIconModal("")}
      >
        <Search
          placeholder="Search Icon"
          onSearch={() => {
            handleSearchIcon();
          }}
          value={searchIconValue}
          onChange={(e) => {
            setSearchIconValue(e.target.value);
          }}
          enterButton
        />
        <div style={{ marginTop: "1rem", padding: "1rem" }}>
          {searchedIcon?.length > 0 ? (
            <Space wrap={true}>
              {searchedIcon?.slice(0, 20).map((icon) => (
                <i
                  onClick={() => {
                    handleAddIcon(iconModal, icon);
                  }}
                  key={icon}
                  className={`fas fa-${icon} fa-2x`}
                  style={{ margin: "1rem", cursor: "pointer" }}
                />
              ))}
            </Space>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <p>
                {searchIconValue.length > 0 ? "No Icon Found" : "Search Icon"}
              </p>

              <p
                style={{
                  fontSize: "1rem",
                  fontWeight: "600",
                  marginTop: ".5rem",
                  marginBottom: ".5rem",
                }}
              >
                OR
              </p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                <p>Upload Custom Icon</p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <ImgCrop
                    rotate
                    modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
                    quality={1}
                    shape="rect"
                    // minZoom={1}
                    // maxZoom={10}
                    // aspect={2 / 1}
                    // modalWidth={530}
                    fillColor="#00000000"
                  >
                    <Upload
                      className="fileList-upload-images"
                      maxCount={1}
                      customRequest={(e) => {
                        handleAddCustomIcon(e, iconModal);
                      }}
                      fileList={[]}
                      listType="picture-card"
                      onRemove={(e) => handleImageRemove(e?.name)}
                      onChange={(e) => {}}
                      accept="image/png"
                    >
                      <PlusOutlined />
                    </Upload>
                  </ImgCrop>
                </div>
              </div>
            </div>
          )}
        </div>
      </Modal>
    </Layout>
  );
};

export default MyQr;
